import React, {useEffect} from 'react'
import {Box, Dialog, IconButton, Typography} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import moment from 'moment'
import {ICameraSnapshot} from '@containers/cameras/types'
import SegmentPhoto from '@containers/monitoringPlatform/passengerVerification/photos/SegmentPhoto'
import sx from '@containers/monitoringPlatform/passengerVerification/photos/sx'

interface IProps {
	snaps: ICameraSnapshot[]
	index: number | null
	onChange: (index: number | null) => void
}

const PhotoViewer = ({snaps, index, onChange}: IProps) => {
	const snap = index != null ? snaps[index] : undefined
	const hasPrev = index != null && index > 0
	const hasNext = index != null && index < snaps.length - 1

	useEffect(() => {
		if (index == null) {
			return
		}
		const onKey = (event: KeyboardEvent) => {
			if (event.key === 'ArrowLeft' && index > 0) {
				onChange(index - 1)
			}
			if (event.key === 'ArrowRight' && index < snaps.length - 1) {
				onChange(index + 1)
			}
		}
		window.addEventListener('keydown', onKey)
		return () => window.removeEventListener('keydown', onKey)
	}, [index, snaps.length, onChange])

	return (
		<Dialog open={!!snap} onClose={() => onChange(null)} maxWidth={false} PaperProps={{sx: sx.viewerPaper}}>
			{snap && <>
				<Box sx={sx.viewerStage}>
					<SegmentPhoto key={`${snap.cameraId}-${snap.snapTime}`} snap={snap} sx={sx.viewerImage}/>
					{hasPrev && <IconButton sx={{...sx.viewerNav, left: 8}} onClick={() => onChange(index! - 1)} aria-label="previous">
						<ChevronLeftIcon/>
					</IconButton>}
					{hasNext && <IconButton sx={{...sx.viewerNav, right: 8}} onClick={() => onChange(index! + 1)} aria-label="next">
						<ChevronRightIcon/>
					</IconButton>}
					<IconButton sx={sx.viewerClose} onClick={() => onChange(null)} aria-label="close">
						<CloseIcon/>
					</IconButton>
				</Box>
				<Box sx={sx.viewerCaption}>
					<Typography component="span" sx={{fontWeight: 600}}>
						{moment(snap.snapTime * 1000).format('HH:mm:ss')} · кам. {snap.cameraNumber}
					</Typography>
					<Typography component="span" sx={{color: 'text.secondary', fontSize: '13px'}}>
						{index! + 1} / {snaps.length}
					</Typography>
					{snap.passengerCount != null && <Typography component="b" sx={{fontWeight: 700}}>
						{snap.passengerCount} пас.
					</Typography>}
				</Box>
			</>}
		</Dialog>
	)
}

export default PhotoViewer
